import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../axiosInstance";


export const submitUpdatePostApi = createAsyncThunk(
    "community/submitUpdatePostApi",
    async (formData, { rejectWithValue }) => {
      try {
        const response = await axiosInstance.post("/community/visitor-document", formData);
        return response.data;
      } catch (error) {
        return rejectWithValue(
          error.response ? error.response.data : error.message
        );
      }
    }
  );